import React from 'react'

import {Tabs, Tab, ToolTip, H4} from '../UI/index.js'
import {getCarrierLabel} from './CarrierLogo.js'

class CarrierSelector extends React.Component {
    render() {
        const {size = 45, carriers, displayCarriers, value, values, prices, onChange, isCustomer, options} = this.props

        return (
            <Tabs style={{height: 'fit-content', marginBottom: 2, width: 'fit-content', paddingBottom: 32, boxSizing: 'content-box'}} value={value} values={values} onChange={onChange}>
                {carriers.map((carrier) => {
                    if (!displayCarriers || displayCarriers.indexOf(carrier.name) > -1) {
                        const carrierLabel = getCarrierLabel(carrier, options)
                        let carrierName = carrierLabel.displayName

                        if (!isCustomer) {
                            carrierName = `${carrierName}${carrier.platform ? ` - ${carrier.platform}` : ''}`
                        }

                        return (
                            <ToolTip key={carrier.name} text={carrierName}>
                                {/* Active and onChange come from Tabs, also through the ToolTip */}
                                <Tab value={carrier.name}>
                                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between'}}>
                                        {value === carrier.name || values && values.indexOf(carrier.name) > -1 ?
                                            <img style={{objectFit: 'contain', height: size, maxWidth: 2 * size}} src={carrierLabel.logo} /> :
                                            <img style={{objectFit: 'contain', height: size, maxWidth: 2 * size, filter: 'grayscale(100%)'}} src={carrierLabel.logo} />
                                        }

                                    </div>
                                </Tab>
                                {prices &&
                                    <H4 style={{marginTop: 6, width: 'fit-content', marginLeft: 'auto', marginRight: 'auto'}}>{prices[carrier.name] ? `€ ${prices[carrier.name]}` : ''}</H4>
                                }
                            </ToolTip>
                        )
                    }
                })}
            </Tabs>
        )
    }
}

export default CarrierSelector
